export default "__VITE_ASSET__BwjrEkK0__"